<template>
  <li
    class="product type-product post-18122 status-publish first instock product_cat-mac product_cat-mac-mini has-post-thumbnail shipping-taxable purchasable product-type-simple"
  >
    <article class="seasidetms_product">
      <div class="seasidetms_product_wrapper_border">
        <figure class="seasidetms_product_img">
          <div class="seasidetms_product_sale_wrap" v-if="product.bage">
            <div class="seasidetms_product_sale_wrap">
              <span class="onsale">
                {{ $t(`bage.${product.bage}`) }}
              </span>
            </div>
          </div>
          <a
            v-if="detailsEnabled"
            href="#"
            @click.stop.prevent="onDetails"
            class="ico-details icon-search icon-quick"
          >
            &nbsp;
          </a>
          <router-link
            :to="
              lang
                ? '/' + lang + '/product/' + categoryPath + '/' + product.slug
                : '/product/' + categoryPath + '/' + product.slug
            "
            :class="{ payParts: product.filters[0].model }"
            @click.native="onClickProdcut(product)"
          >
            <img
              :width="productImgWidth"
              :height="productImgHeight"
              :src="productImgSrc"
              :alt="$h.getAlt(productName)"
              :title="productName"
              class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail lazyloaded"
            />
            <!--            :srcset="productImgSrcSet"-->
            <!--            :sizes="productImgSizes"-->
          </router-link>
          <div class="seasidetms_product_sale_wrap"></div>
        </figure>
        <span class="out-of-stock" v-if="!product.stock">
          {{ $t('outOfStock') }}
        </span>
        <div class="seasidetms_product_inner">
          <header class="seasidetms_product_header entry-header">
            <div class="h3 seasidetms_product_title entry-title">
              <router-link
                :to="
                  lang
                    ? '/' +
                      lang +
                      '/product/' +
                      categoryPath +
                      '/' +
                      product.slug
                    : '/product/' + categoryPath + '/' + product.slug
                "
                @click.native="onClickProdcut(product)"
              >
                {{ productName }}
              </router-link>
            </div>
          </header>
          <div class="seasidetms_product_info_wrap">
            <div class="seasidetms_product_info">
              <span class="price price-uah-catalog" v-if="product.newPrice">
                <span class="woocommerce-Price-amount amount">
                  <s>
                    {{ product.price }}
                    <span>
                      <span class="woocommerce-Price-currencySymbol">грн</span>
                    </span>
                  </s>
                </span>
                <span
                  style="margin-left: 50px; color: rgba(255, 67, 0, 0.9)"
                  class="price-ukr"
                >
                  <span v-html="$h.formatPrice(product.newPrice)"></span>грн
                </span>
              </span>
              <span
                class="price"
                style="justify-content: center !important"
                v-else
              >
                <span class="woocommerce-Price-amount amount"></span>
                <span class="price-ukr">
                  <span v-html="$h.formatPrice(product.price)"></span>грн
                </span>
              </span>
            </div>
            <rating :rating="product.rating" />
            <div class="seasidetms_product_add_wrap">
              <div class="seasidetms_product_add_inner">
                <a
                  href="#"
                  id="add-to-cart-button"
                  class="seasidetms_product_button add_to_cart_button seasidetms_add_to_cart_button product_type_simple ajax_add_to_cart"
                  :title="$t('toCart')"
                  @click.stop.prevent="onAddToCart"
                  v-if="!product.preorder && product.stock && !inCart"
                >
                  <span>
                    {{ $t('toCart') }}
                  </span>
                </a>

                <a
                  href="#"
                  class="seasidetms_product_button notify-on-stock"
                  @click.stop.prevent="onNotifyOnStock(product)"
                  v-if="!product.preorder && !product.stock"
                >
                  {{ $t('notifyOnStock') }}
                </a>

                <!-- <div class="hidden-button-on-tale" v-if="!product.preorder && product.stock && !inCart">
                <a
                  id="buy-in-one-click"
                  class="seasidetms_product_button add_to_cart_button seasidetms_add_to_cart_button product_type_simple ajax_add_to_cart one-click buy-one-click-category"
                  style="cursor: pointer;"
                  @click.stop.prevent="onQuickOrder"
                  v-if="!product.preorder && product.stock && !inCart"
                >
                  <span>
                    {{ $t('buyOneClick') }}
                  </span>
                </a>
                </div> -->
                <!-- item exist in cart , class added_to_cart -->
                <router-link
                  id="add-to-cart-button"
                  :to="lang ? '/' + lang + '/cart' : '/cart'"
                  class="seasidetms_product_button wc-forward"
                  :title="$t('showCart')"
                  v-if="!product.preorder && product.stock && inCart"
                >
                  <span>
                    {{ $t('showCart') }}
                  </span>
                </router-link>
                <!-- not in stock, notify on stock modal -->
                <!-- <a
                  href="#"
                  class="seasidetms_product_button notify-on-stock"
                  @click.stop.prevent="onNotifyOnStock(product)"
                  v-if="!product.preorder && !product.stock"
                >
                  {{ $t('notifyOnStock') }}
                </a> -->
                <!-- not in stock but on presale, preorder modal -->
                <a
                  href="#"
                  class="seasidetms_product_button on-preorder"
                  @click.stop.prevent="onPreOrder(product)"
                  v-if="product.preorder"
                >
                  {{ $t('preorder') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="hidden-button-on-tale"
        v-if="!product.preorder && product.stock && !inCart"
      >
        <a
          id="buy-in-one-click"
          class="seasidetms_product_button add_to_cart_button seasidetms_add_to_cart_button product_type_simple ajax_add_to_cart one-click buy-one-click-category"
          style="cursor: pointer"
          @click.stop.prevent="onQuickOrder"
          v-if="!product.preorder && product.stock && !inCart"
        >
          <span>
            {{ $t('buyOneClick') }}
          </span>
        </a>
      </div>
    </article>
  </li>
</template>

<script>
import { mapMutations } from 'vuex'
import Rating from '@/components/Rating'
import ProductItemMixin from '@/components/product/ProductItemMixin'

export default {
  name: 'ProductTile',
  components: { Rating },
  mixins: [ProductItemMixin],
  methods: {
    onQuickOrder() {
      this.$store.commit('setProductModal', this.product)
      this.setQuickOrderModal(true)
    },
    ...mapMutations(['setQuickOrderModal']),
  },
  data() {
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
.seasidetms_product {
  border-width: 0px;
}
.seasidetms_product:hover {
  border-width: 0px;
}

.seasidetms_product:hover .seasidetms_product_wrapper_border {
  border-width: 2px;
}
@media screen and (max-width: 950px) {
  .seasidetms_product {
    box-shadow: unset;
    border: 2px solid#ddd;
  }
  .seasidetms_product .seasidetms_product_wrapper_border {
    border-width: 0px;
    padding-bottom: 0px;
  }
  .seasidetms_product:hover {
    box-shadow: unset;
    border-width: 2px;
  }
  .seasidetms_product:hover .seasidetms_product_wrapper_border {
    border-width: 0px;
  }

  .seasidetms_owl_slider_item .seasidetms_product {
    box-shadow: unset;
    border: 0px;
  }
  .seasidetms_owl_slider_item
    .seasidetms_product
    .seasidetms_product_wrapper_border {
    border-width: 1px;
    padding-bottom: 10px;
  }
}
</style>
